import { useSyncExternalStore } from "react";
import usePostMessageConfig from "./usePostMessageConfig";
import useMemoizedSelector from "../useMemoizedSelector";

const useConfigProductConfig = () => {
	const { createSelector, subscribe } = usePostMessageConfig();

	//need memoization here since this selector always re-creates its output
	const memoizedSelector = useMemoizedSelector((productConfigs, activeConfigs) =>
		(productConfigs && activeConfigs) ?
			activeConfigs.map((current) =>
				current ? { ...current, config: productConfigs[current.configIndex] } : undefined
			).filter(Boolean) : undefined,
	);

	return useSyncExternalStore(
		subscribe,
		createSelector((config) =>
			memoizedSelector(config.productConfigs, config.activeConfigs)),
	);
};

export default useConfigProductConfig;
